import styled from "styled-components";

export const PersonalInfoViewCardsContainer = styled.div`
  > *:not(:last-child) {
    margin-bottom: 1.2rem;
  }
`;
